import type {
  WorkspaceMemberInvite,
  WorkspaceMemberInvitePayloadApi,
  WorkspaceUserSearchResponse,
  WorkspaceUserSearchResponseApi,
  WorkspaceUserSearchResult,
  WorkspaceUserSearchResultApi,
} from "./workspaceMembers.types";
import { toAvatarUrl } from "../account/accountProfileMappers";

export const mapWorkspaceUserSearchResult = (
  api: WorkspaceUserSearchResultApi,
): WorkspaceUserSearchResult => ({
  id: api.id,
  name: api.name,
  email: api.email,
  title: api.title,
  avatarUrl: toAvatarUrl(api.avatar_url),
});

export const mapWorkspaceUserSearchResponse = (
  api: WorkspaceUserSearchResponseApi,
): WorkspaceUserSearchResponse => ({
  query: api.query,
  items: api.items.map(mapWorkspaceUserSearchResult),
});

export const mapMemberInvitesToApi = (
  invites: WorkspaceMemberInvite[],
): WorkspaceMemberInvitePayloadApi[] =>
  invites.map((invite) =>
    invite.kind === "user"
      ? { email: invite.email, role: invite.role, user_id: invite.userId }
      : { email: invite.email, role: invite.role },
  );
